import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import _isNull from 'lodash/isNull';
// Core components
import Box from 'components/core/Box';
// Custom
import ErrorsDisplayer from 'components/misc/ErrorsDisplayer';

const FormDialogTemplate = ({
  errors, scrollToErrors, additionalError, children,
}) => {
  const errorDisplayer = useRef(null);

  if ((_isNull(scrollToErrors) || scrollToErrors) && errors) {
    errorDisplayer.current.scrollIntoView({
      behavior: 'smooth',
    });
  }

  return (
    <React.Fragment>
      <div ref={errorDisplayer}>
        {errors
          && (
          <div className="pt-3 px-3">
            <ErrorsDisplayer noFormRef errors={errors} additionalError={additionalError} />
          </div>
          )}
      </div>
      <Box type="defaultBackground" className="p-3">
        {children}
      </Box>
    </React.Fragment>
  );
};

FormDialogTemplate.propTypes = {
  scrollToErrors: PropTypes.bool,
  errors: PropTypes.shape({
    global: PropTypes.string.isRequired,
  }),
  additionalError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  children: PropTypes.node.isRequired,
};

FormDialogTemplate.defaultProps = {
  scrollToErrors: null,
  errors: null,
  additionalError: null,
};

module.exports = FormDialogTemplate;



// WEBPACK FOOTER //
// ./components/templates/FormDialogTemplate.js